import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenanceTemplatesComponent } from "./maintenance-templates.component";
import { CreateEditTemplatesComponent } from "./create-edit-templates/create-edit-templates.component";
import { ListTemplatesComponent } from "./list-templates/list-templates.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesTemplates: Routes = [
  {
    path: "",
    component: MaintenanceTemplatesComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListTemplatesComponent,
      },
      {
        path: "creacion",
        component: CreateEditTemplatesComponent,
        data: {
          operation: "creacion",
        },
      },
      {
        path: "edicion/:id",
        component: CreateEditTemplatesComponent,
        data: {
          operation: "edicion",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesTemplates)],
  exports: [RouterModule],
})
export class TemplatesRoutingModule {}
